export default __webpack_public_path__ + "static/media/homePage_1scene.c31e11ba.png";